import React from 'react';
import { Alert, SxProps, Theme } from '@mui/material';

type FormValidationAlertProps = {
  message: string | null;
  onClose?: () => void;
  sx?: SxProps<Theme>;
};

const FormValidationAlert: React.FC<FormValidationAlertProps> = ({ message, onClose, sx }) => {
  if (!message) return null;
  return (
    <Alert severity="error" onClose={onClose} sx={{ mx: 3, mb: 1, ...sx }}>
      {message}
    </Alert>
  );
};

export default FormValidationAlert;
